module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/why_we_are_doing_this_sm-acd26fbcae5dd163fdfb46bbc4ea9502.svg";